import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import {
  ERROR_CODE,
  REFERRAL_SMS_PERMISSIONS,
  DEFAULT_INBOX_DATE_FILTER,
  RECOGNITION_POST_PERMISSIONS,
} from "../constants/constants";
import { fetchUser } from "../services/applications";

import { get } from "../utils/localStorage";
import { isEmpty as isStringEmpty } from "../utils/string";

const useUser = () => {
  const navigate = useNavigate();

  const { data: user, isLoading, error } = useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      const userRole = get("userRole");
      
      if (isStringEmpty(get("token")) && isStringEmpty(get("refreshToken"))) {
        return null;
      }

      try {
        const response = await fetchUser(userRole);
        
        return {
          ...response?.result,
          email: response?.result?.email || get("email"),
          configuration: {
            ...response?.result?.configuration,
            enable_referral_sms:
              !!REFERRAL_SMS_PERMISSIONS[
                response?.result?.name || response?.result?.agency
              ],
            enable_recognition_post:
              !!RECOGNITION_POST_PERMISSIONS[
                response?.result?.name || response?.result?.agency
              ],
            default_date_filter:
              DEFAULT_INBOX_DATE_FILTER[
                response?.result?.name || response?.result?.agency
              ],
          },
        };
      } catch (error) {
        if (error?.code === ERROR_CODE.CANCELED) {
          navigate("/");
        }
        throw error;
      }
    },
    enabled: !isStringEmpty(get("token")) || !isStringEmpty(get("refreshToken")),
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return { 
    user: user || {}, 
    isLoading, 
    error,
  };
};

export default useUser;
